module.exports = {"id":"dp3_1l3q1","text":"Developing digital content","instructions":"Templates can improve efficiency when creating digital content.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.1","questionType":"PickOne","random":false,"options":[{"id":"dp3_1l3q1-a1","text":"True","score":3.7},{"id":"dp3_1l3q1-a2","text":"Not sure","score":1.3},{"id":"dp3_1l3q1-a3","text":"False","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.1/l3q1.json
// module id = 1115
// module chunks = 41